import { QuoteFlowType } from 'sharedEnums/quote-flow-type';

export const acceptableBaseRoutes = new Set<QuoteFlowType>([
    QuoteFlowType.HomeContents,
    QuoteFlowType.Vehicle,
]);
